import type { IFrontendServiceContainer } from '@phi/frontend/service-container';

export const logging_api_factory = ({ api }: IFrontendServiceContainer) => ({
    log: api.only_when_authorised(api.helper('log')),
});
